export enum SharePointLinksActionType {
  FETCH_SHAREPOINTLINKS = 'FETCH_SHAREPOINTLINKS'
}
